import { combineReducers } from "redux";
import allPostbases from "./allPostbases";

export default combineReducers({ allPostbases: allPostbases });



// WEBPACK FOOTER //
// ./src/redux/reducers/index.js